var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"big-buttons row"},_vm._l((_vm.options),function(option,index){return _c('div',{key:index,staticClass:"col-12 col-lg mb-6 pb-3"},[_c('div',{staticClass:"big-button",class:{
        active: _vm.value === option.id,
        inactive: _vm.value !== option.id,
        login: _vm.login
      },on:{"click":function($event){return _vm.$emit('input', option.id)}}},[_c('img',{attrs:{"src":option.src,"alt":option.name}}),_c('span',{staticClass:"button-name",class:{ login: _vm.login }},[_vm._v(_vm._s(option.name))])])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }